import { render, staticRenderFns } from "./TemplateLoaderEffect.vue?vue&type=template&id=7d79bf14&"
import script from "./TemplateLoaderEffect.vue?vue&type=script&lang=ts&"
export * from "./TemplateLoaderEffect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports